import React from 'react';
import { Link } from '@reach/router';

import HeaderStyles from './Header.styles';

import LabIcon from '../../assets/images/the-lab-logo-white.svg';

const Header: React.FC = () => (
  <HeaderStyles>
    <div className="title">
      <h1>
        <Link to="/">O2 Explore</Link>
      </h1>
    </div>

    <div className="lab-logo">
      <a href="https://o2lab.co.uk/" rel="noopener noreferrer" target="_blank">
        <img src={LabIcon} alt="" />
      </a>
    </div>
  </HeaderStyles>
);

export default Header;
